import React from 'react';
import Scrollbar from 'react-smooth-scrollbar';
import classNames from 'classnames';
import SidebarContent from './SidebarContent.view';

const Sidebar = ({ changeMobileSidebarVisibility, sidebarShow, sidebarCollapse }) => {
  const sidebarClass = classNames({
    sidebar: true,
    'sidebar--show': sidebarShow,
    'sidebar--collapse': sidebarCollapse
  });

  return (
    <div className={sidebarClass}>
      <button type='button' className='sidebar__back' onClick={changeMobileSidebarVisibility} />
      <Scrollbar className='sidebar__scroll scroll'>
        <div className='sidebar__wrapper sidebar__wrapper--desktop'>
          <SidebarContent onClick={() => {}} sidebarCollapse={sidebarCollapse} />
        </div>
        <div className='sidebar__wrapper sidebar__wrapper--mobile'>
          <SidebarContent
            onClick={changeMobileSidebarVisibility}
            sidebarCollapse={sidebarCollapse}
            sidebarShow={sidebarShow}
          />
        </div>
      </Scrollbar>
    </div>
  );
};

export default Sidebar;
